import Http from "../utils/axios";

// app配置
export function apiConfig(data) {
  return Http.post("/index/get_c", data);
}
// 轮播图列表
export function apiBannerList(data) {
  return Http.post("/index/getban", data);
}

// 通知公告
export function apiNoticeList(data) {
  return Http.post("/index/getchat", data);
}

// 分类
export function apiSortList(data) {
  return Http.post("/index/getColumnList", data);
}
export function apiGetDownloaded(data) {
  return Http.post("/index/getDownloaded", data);
}
export function apiGetDownloadedReward(data) {
  return Http.post("/index/getDownloadedReward", data);
}
export function apiCheckIsDownloaded(data) {
  return Http.post("/index/checkIsDownloaded", data);
}

// 游戏收藏
export function apiGameCollect(data) {
  return Http.post("/index/like_game", data);
}

export function apiGameDiscollect(data) {
  return Http.post("/index/c_like_game", data);
}

// 游戏搜素
export function apiGameSearch(data) {
  return Http.post("/index/game_like", data);
}
export function apiFetchGames(data) {
  return Http.post("/index/fetch_games", data);
}
// 我的收藏
export function apiMyCollectList(data) {
  return Http.post("/index/get_game", data);
}

// 登录
export function apiLogin(data) {
  return Http.post("/user/login", {
    ...data,
    area: 55,
  });
}
// 修改用户信息 手机号 账号 邮箱
export function apiEditUserinfo(data) {
  return Http.post("/user/profile", data);
}
// 二级密码修改
export function apiSecondPasswordEdit(data) {
  return Http.post("/user/editSecondaryPassword", data);
}
// 解绑 / 绑定手机号
export function apiEditPhone(data) {
  return Http.post("/user/bindPhone", {
    ...data,
    area: 55,
  });
}

// 验证token
export function apiCheckToken(data) {
  return Http.post("/user/getUserinfo", data, {
    meta: { showError: false }, // 将 showError 放在 meta 中
  });
}
// 注册
export function apiRegister(data) {
  return Http.post("/user/register", {
    ...data,
    area: 55,
  });
}
// 重置密码
export function apiPasswordReset(data) {
  return Http.post("/user/findPwdType", {
    ...data,
    area: 55,
  });
}
// 重置二级密码
export function apiSecondaryPasswordReset(data) {
  return Http.post("/user/findSecondaryPwd", {
    ...data,
    area: 55,
  });
}
export function apiSendEmailCode(data) {
  return Http.post("/index/send_email_mobile", data);
}

// 退出登录
export function apiLogout(data) {
  return Http.post("/user/logout", data);
}
// 进入游戏登录
export function apiGameLogin(data) {
  return Http.post("/index/in_game", data);
}
// 游戏详情
export function apiGameDetail(data) {
  return Http.post("/index/look_like", data);
}

//获取vip等级列表
export function apiVipLevelList(data) {
  return Http.post("/index/get_vips", data);
}

// 活动 平台兑换码 领取奖金
export function apiApplyBonus(data) {
  return Http.post("/Activity/translate", data);
}
// 活动 签到有奖
export function apiCheckIn(data, showError = true) {
  return Http.post("/Activity/sign", data, {
    meta: { showError }, // 将 showError 放在 meta 中
  });
}

// 系统 邮件消息列表
// export function apiNotificationList(data) {
//   return Http.post("Message/readMessage", data);
// }
export function apiNotificationList(data) {
  return Http.post("/index/get_msg", data);
}
// 系统 邮件消息列表 读取
export function apiNotificationRead(data) {
  return Http.post("/Message/readMessageStatus", data);
}
// 系统 邮件消息列表 删除
export function apiNotificationDel(data) {
  return Http.post("/Message/deleteMessage", data);
}
export function getRewardList(data){
  return Http.post("/index/rewardList", data);
}
export function checkDailyRewards(data){
  return Http.post("/index/checkDailyRecharge", data);
}
export function getDailyRewards(data){
  return Http.post("/index/getDailyRechargeReward", data);
}
export function apiTransferScore(data){
  return Http.post("/index/transferScore", data);
}
export function apiReceiveMysteryReward(data){
  return Http.post("/index/receiveMysteryReward", data);
}

export function apiReceiveRegReward(data){
  return Http.post("/index/getRegisterReward", data);
}
export function apiReceiveScReward(data){
  return Http.post("/index/getScReward", data);
}
export function apiCheckMysteryReward(data){
  return Http.post("/index/checkMysteryReward", data);
}
export function apiCheckIsNotified(data){
  return Http.get("/index/checkIsNotified", data);
}
export function apiGetNotified(data){
  return Http.post("/index/getNotified", data);
}
export function apiGetNotifiedReward(data){
  return Http.post("/index/getNotifiedReward", data);
}
export function apiGetTodayAndYesterdayBet(data){
  return Http.post("/index/getTodayAndYesterdayBet", data);
}
// vip升级奖励 周奖励 领取
export function apiReceiveAward(data) {
  return Http.post("/index/getDayReward", data);
}
export function apiFetchUpgradeReward(data) {
  return Http.post("/index/getUpgradeReward", data);
}
export function apiFetchRechargeReward(data) {
  return Http.post("/index/getRechargeReward", data);
}
export function apiFetchTotalReward(data) {
  return Http.post("/index/getTotalReward", data);
}
export function apiFetchLossReward(data) {
  return Http.post("/index/getLossReward", data);
}
// 充值类型
// export function apiDepositType(data) {
//   return Http.post("PayApi/lists", data);
// }
export function apiDepositType(data) {
  return Http.post("/index/get_rechlist", data);
}
// 充值 根据分类对应方式
export function apiDepositWayByType(data) {
  return Http.post("/PayApi/payList", data);
}
// 充值 根据方式对应通道ID
export function apiChannelIDByWay(data) {
  return Http.post("/PayApi/payListByModeId", data);
}
export function apiReacharge(data) {
  return Http.post("/index/Withdraw_recharge", data);
}
// 充值 创建充值订单
export function apiCreateDeposit(data) {
  return Http.post("/PayApi/pay", data);
}
// 充值 充值记录
export function apiDepositRecord(data) {
  return Http.post("/index/Wit_rech_list", data);
}

// 提现 获取提现方式
// export function apiWithdrawWay(data) {
//   return Http.post("Exchanges/getBankList", data);
// }
export function apiWithdrawWay(data) {
  return Http.post("/index/is_bank", data);
}
// 提现记录列表
export function apiWithdrawRecord(data) {
  return Http.post("/index/Wit_rech_list", data);
}

// 获取提现方式 对应用户已绑定钱包
export function apiWithdrawWalletByWay(data) {
  return Http.post("/index/bankList", data);
}

export function apiSelectWithdrawWallet(data) {
  return Http.post("/index/selectBank", data);
}
// 提现 添加钱包
export function apiWithdrawAddWallet(data) {
  return Http.post("/index/addBank", {
    ...data,
    area: 55,
  });
}
// 提现 删除钱包
export function apiWithdrawDelWallet(data) {
  return Http.post("/index/delBank", data);
}
// 提现 编辑钱包
// export function apiWithdrawEditWallet(data) {
//   return Http.post("Exchanges/editBank", {
//     ...data,
//     area: 63,
//   });
// }
export function apiWithdrawEditWallet(data) {
  return Http.post("/index/editBank", {
    ...data,
    area: 55,
  });
}
// 提现 提交订单 0余额，1佣金

export function apiCreateWithdraw(data) {
  return Http.post("/index/exchange", data);
}
// 代理 领取邀请奖励
export function apiReviceInviteRewrad(data) {
  return Http.post("/Activity/pullNewReward", data);
}

// 代理 团队数据
export function apiTeamData(data) {
  return Http.post("/Distribution/getTeamData", data);
}
// 代理 佣金奖励数据
export function apiCommissionBonusData(data) {
  return Http.post("/Distribution/getCommission", data);
}

// 代理 短链接生成
export function apiAffiliateUrl(data) {
  return Http.post("/index/get_links", data, {
    meta: { showError: false }, // 将 showError 放在 meta 中
  });
}
// 代理 短链接解析
export function apiAffiliateUrlParse(data) {
  return Http.post("/Share/getParams", data, {
    meta: { showError: false }, // 将 showError 放在 meta 中
  });
}

// 代理 邀请活动 奖励列表
export function apiActivityInviteRewradList(data) {
  return Http.post("/Activity/pullNew", data);
}

// 个人游戏战绩统计
// export function apiGameRecord(data) {
//   return Http.post("Distribution/getFlow", data);
// }
export function apiGameRecord(data) {
  return Http.post("/index/find_bets", data);
}

//奖励 返水奖金列表
export function apiBonusCashbackList(data) {
  return Http.post("/vip/getClaimedRewardList", data);
}

// 代理佣金排行榜
export function apiRankList(data) {
  return Http.post("/Distribution/getCommissionRanking", data);
}

// 新vip
// 根据vip等级获取是否有领取的数据
export function apiVipRewardByLevel(data) {
  return Http.post("/vip/getRewardList", data);
}

// 获取用户玩过的游戏
export function apiUserPlayed(data) {
  return Http.post("/Distribution/getUserPlayed", data);
}

// 获取活动列表
export function apiActivityList(data) {
  return Http.post("/index/activity", data);
}

// 根据等级获取签到配置
export function apiSignConfigByLevel(data) {
  return Http.post("/Activity/getSignConfig", data);
}

// 获取客服配置信息
export function apiCustomerServiceConfig(data) {
  return Http.post("/Index/get_customer_service_config", data);
}

// 获取帮助中心信息
export function apiHelpConfig(data) {
  return Http.post("/index/get_fool", data);
}

// 获取左侧菜单列表
export function apiMenuList(data) {
  return Http.post("/index/getMenuList", data);
}
// 根据菜单ID获取绑定的游戏
export function apiMenuGameList(data) {
  return Http.post("/Index/getMenuGameList", data);
}
// 获取渠道绑定的厂商
export function apiChannelMfrList(data) {
  return Http.post("/index/getGameList", data);
}

// 根据导航ID获取绑定的游戏
export function apiColumnGameList(data) {
  return Http.post("/index/getGameList", data);
}

// 获取推荐列表
export function apiRecommendList(data) {
  return Http.post("/Index/getRecommendList", data);
}

// 获取随机游戏
export function apiGetRandomGame(data) {
  return Http.get("/index/get_random_game", data);
}

// 获取验证码
export function apiSendSms(data) {
  return Http.post("/SmsApi/sendSms", {
    area: 55,
    ...data,
  });
}

// 校验二级密码
export function apiCheckSecondaryPassword(data) {
  return Http.post("/User/checkSecondaryPassword", data);
}
// ==================== 转盘活动相关 ====================
// 获取转盘信息（剩余次数、累计奖金、奖品列表）
export function apiGetSpinInfo(data) {
  return Http.post("/index/getSpinInfo", data);
}
// 执行抽奖
export function apiSpin(data) {
  return Http.post("/index/spin", data);
}
// 获取中奖记录列表
export function apiSpinRecords(data) {
  return Http.post("/index/spinRecords", data);
}
export function apiGetLotteryChances(data) {
  return Http.post("/index/getLotteryChances", data);
}
export function apiLotterySpin(data) {
  return Http.post("/index/lotterySpin", data);
}
export function apiGetUserLotteryRecords(data) {
  return Http.post("/index/getUserLotteryRecords", data);
}
export function apiGetLotteryRecords(data) {
  return Http.post("/index/getLotteryRecords", data);
}
// 获取流水转盘奖品列表
export function apiGetLotteryPrizes(data) {
  return Http.post("/index/getLotteryPrizes", data);
} 
// 获取流水转盘奖品配置
export function apiGetLotteryPrizesConfig(data) {
  return Http.post("/index/getLotteryPrizesConfig", data);
}
export function apiGetUserPrizeStars(data) {
  return Http.post("/index/getUserPrizeStars", data);
}

// 获取邀请统计信息
export function apiGetInviteStats(data) {
  return Http.post("/index/getInviteStats", data);
}

// 领取邀请奖励
export function apiClaimInviteReward(data) {
  return Http.post("/index/claimInviteReward", data);
}
// 检查兑换码
export function apiCheckCoupon(data) {
  return Http.post("/index/checkCoupon", data);
}

// 领取兑换码
export function apiClaimCoupon(data) {
  return Http.post("/index/claimCoupon", data);
}

// 获取用户已领取的兑换码记录
export function apiGetUserCouponRecords(data) {
  return Http.post("/index/getUserCouponRecords", data);
}
// 获取红包次数
export function apiGetRedPacketInfo(data){
  return Http.post("/index/getRedPacketInfo", data);
}

// 打开金色红包
export function apiOpenRedPacket(data){
  return Http.post("/index/openRedPacket", data);
}
export function apiCheckTodayRedpacketStatus(data){
  return Http.post("/index/checkTodayRedpacketStatus", data);
}
// Jackpot
export function apiJackpot(data) {
  return Http.post("/index/index", data);
}
